const getEnvVariable = (name, defaultValue = null) => {
  return process.env[name] || defaultValue;
};
export default getEnvVariable;
